
import React from 'react';
import { ReactComponent as DownloadIcon } from './csv-file-icon.svg';

const DownloadCsvIcon: React.FC<{ data: object[], filename: string, filter:boolean }> = ({ data, filename, filter }) => {
  const handleDownload = () => {
    if (!data.length) {
      console.error('Empty data array');
      return;
    }
    if(filter)
      data=data.filter((d:any)=>!d.checkIn);

    const csvRows = [
      "Vorname,Nachname,Geburtstag,Email,Straße,Nr,PLZ,Stadt,IBAN,BIC,SOLI,AnBoard", // header
      ...data.map((obj : any) => {
          return obj.prename+","+obj.name+","+obj.birth+","+obj.mail+","+obj.street+","+obj.number+","+obj.plz+","+obj.city+","+obj.iban+","+obj.bic+","+(obj.soli==="true"?"ja":"nein")+","+(obj.checkIn?"ja":"nein");
      }
      )
    ];

    const csvContent = csvRows.join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  return (
    <button onClick={handleDownload} style={{ background: 'none', border: 'none', cursor: 'pointer' }}>
      <DownloadIcon width={154} height={154} fill="#FFEC01"/>
    </button>
  );
};

export default DownloadCsvIcon;
